import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { CustomerBillingOtherCustomerModel } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer.model';
import {
    fiInvoiceMethodType,
    fiInvoiceMethodTypes,
} from '@fi-app/customer-billing/customer-billing-invoice/invoice-method-type';
import { BillingContactUsingType } from '@fi-app/billing/billing-contact-type';
import { VATs } from '../../../customer-billing-components/VAT';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { BillingService } from '@fi-app/billing/billing.service';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';

@Component({
    selector: 'fi-customer-billing-reseller-invoice-info',
    templateUrl: './customer-billing-reseller-invoice-info.component.html',
    styleUrls: ['./customer-billing-reseller-invoice-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CustomerBillingResellerInvoiceInfoComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: CustomerBillingResellerInvoiceInfoComponent,
        },
    ],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-reseller-invoice-info' },
    standalone: false,
})
export class CustomerBillingResellerInvoiceInfoComponent
    extends ControlValueAccessorValidatorBase<CustomerBillingOtherCustomerModel>
    implements OnInit
{
    invoiceLanguageListData = new DropdownSettingsModelV2<IContentLanguage>({
        filterBy: 'Name',
    });
    invoiceCurrencyListData = new DropdownSettingsModelV2<INameIdObj>({
        filterBy: 'Name',
    });
    fiInvoiceMethodTypes = fiInvoiceMethodTypes;
    BillingContactUsingType = BillingContactUsingType;
    VATs = VATs;
    FiCustomValidatorPatterns = FiCustomValidatorPatterns;

    constructor(
        private injector: Injector,
        private contentLanguages: ContentLanguagesService,
        private billingService: BillingService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.setInvoicesListsData();
    }

    private setInvoicesListsData() {
        this.invoiceLanguageListData.setDataSet(this.contentLanguages.GetApplicationLanguages());
        this.invoiceCurrencyListData.setDataSet(this.billingService.GetBillingCurrencies());
    }

    isReceiverInvoiceMethodEmail(): boolean {
        return this.ngModel.InvoiceInfo.ReceiveTo === fiInvoiceMethodType.Email;
    }
}
